// Sticky Add to Cart visibility logic
// Shows sticky add-to-cart only when the main button is scrolled out of view

document.addEventListener('DOMContentLoaded', function() {
  var productForm = document.querySelector('ajax-cart-product-form');
  var stickyCart = document.getElementById('sticky-add-to-cart');
  if (!productForm || !stickyCart) return;

  // Hide sticky on load using Tailwind hidden class
  stickyCart.classList.add('hidden');

  function checkFormOutOfView() {
    var rect = productForm.getBoundingClientRect();
    // Only show sticky if the form's bottom is above the viewport
    if (rect.bottom < 0) {
      stickyCart.classList.remove('hidden');
      stickyCart.classList.add('flex');
    } else {
      stickyCart.classList.add('hidden');
      stickyCart.classList.remove('flex');
    }
  }

  window.addEventListener('scroll', checkFormOutOfView);
  window.addEventListener('resize', checkFormOutOfView);
  checkFormOutOfView();
});
